<template>
  <main class="container py-5 text-center">
    <h1>Страница не найдена</h1>
    <p>Возможно, адрес изменился или страница была удалена.</p>
    <router-link to="/" class="btn btn-primary">На главную</router-link>
  </main>
</template>
